module.exports = __webpack_public_path__ + "static/media/icon-preapproval-waiting.459c18a5.svg";